import { OUTCOME_APP_PROMOTION, OUTCOME_LEADS, OUTCOME_SALES } from '../../../../constants/campaigns'
import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

export const useShowAttributionWindows = (campaignObjective, platform) => {
  if (platform !== FACEBOOK_PLATFORM) return false
  // If facebook campaign goal is leads or conversions or app installs, fetch and show attribution windows
  return (
    campaignObjective === OUTCOME_LEADS ||
    campaignObjective === OUTCOME_SALES ||
    campaignObjective === OUTCOME_APP_PROMOTION
  )
}
